/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TenantLicenseDataDtoLicensePlan } from './TenantLicenseDataDtoLicensePlan';
import {
    TenantLicenseDataDtoLicensePlanFromJSON,
    TenantLicenseDataDtoLicensePlanFromJSONTyped,
    TenantLicenseDataDtoLicensePlanToJSON,
} from './TenantLicenseDataDtoLicensePlan';
import type { TenantLicenseDeviceDto } from './TenantLicenseDeviceDto';
import {
    TenantLicenseDeviceDtoFromJSON,
    TenantLicenseDeviceDtoFromJSONTyped,
    TenantLicenseDeviceDtoToJSON,
} from './TenantLicenseDeviceDto';
import type { TenantLicenseOptionDto } from './TenantLicenseOptionDto';
import {
    TenantLicenseOptionDtoFromJSON,
    TenantLicenseOptionDtoFromJSONTyped,
    TenantLicenseOptionDtoToJSON,
} from './TenantLicenseOptionDto';

/**
 * 
 * @export
 * @interface TenantLicenseDataDto
 */
export interface TenantLicenseDataDto {
    /**
     * 
     * @type {TenantLicenseDataDtoLicensePlan}
     * @memberof TenantLicenseDataDto
     */
    licensePlan?: TenantLicenseDataDtoLicensePlan | null;
    /**
     * 
     * @type {Array<TenantLicenseOptionDto>}
     * @memberof TenantLicenseDataDto
     */
    options?: Array<TenantLicenseOptionDto> | null;
    /**
     * 
     * @type {Array<TenantLicenseDeviceDto>}
     * @memberof TenantLicenseDataDto
     */
    devices?: Array<TenantLicenseDeviceDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDataDto
     */
    licenseMetaModelVersion?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantLicenseDataDto
     */
    readonly isValid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDataDto
     */
    $type?: TenantLicenseDataDtoTypeEnum;
}


/**
 * @export
 */
export const TenantLicenseDataDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedLicenseComponentDtoTenantLicenseDataDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.LicenseComponent.Dto.TenantLicenseDataDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TenantLicenseDataDtoTypeEnum = typeof TenantLicenseDataDtoTypeEnum[keyof typeof TenantLicenseDataDtoTypeEnum];


/**
 * Check if a given object implements the TenantLicenseDataDto interface.
 */
export function instanceOfTenantLicenseDataDto(value?: unknown): value is TenantLicenseDataDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TenantLicenseDataDtoTypeEnum)[0];
}

export function TenantLicenseDataDtoFromJSON(json: any): TenantLicenseDataDto {
    return TenantLicenseDataDtoFromJSONTyped(json, false);
}

export function TenantLicenseDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantLicenseDataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'licensePlan': !exists(json, 'licensePlan') ? undefined : TenantLicenseDataDtoLicensePlanFromJSON(json['licensePlan']),
        'options': !exists(json, 'options') ? undefined : (json['options'] === null ? null : (json['options'] as Array<any>).map(TenantLicenseOptionDtoFromJSON)),
        'devices': !exists(json, 'devices') ? undefined : (json['devices'] === null ? null : (json['devices'] as Array<any>).map(TenantLicenseDeviceDtoFromJSON)),
        'licenseMetaModelVersion': !exists(json, 'licenseMetaModelVersion') ? undefined : json['licenseMetaModelVersion'],
        'isValid': !exists(json, 'isValid') ? undefined : json['isValid'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TenantLicenseDataDtoToJSON(value?: TenantLicenseDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'licensePlan': TenantLicenseDataDtoLicensePlanToJSON(value.licensePlan),
        'options': value.options === undefined ? undefined : (value.options === null ? null : (value.options as Array<any>).map(TenantLicenseOptionDtoToJSON)),
        'devices': value.devices === undefined ? undefined : (value.devices === null ? null : (value.devices as Array<any>).map(TenantLicenseDeviceDtoToJSON)),
        'licenseMetaModelVersion': value.licenseMetaModelVersion,
        '$type': value.$type,
    });
}

